import { memo } from 'react';
import { UserRegister5Template } from 'components/templates/UserRegister5Template';

type Props = {};

export const UserRegister5Page = memo((_props: Props) => {
	return <UserRegister5Template />;
});
